import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import { FaAngleLeft,FaAngleRight } from "react-icons/fa6";
import Slider from "react-slick";
import { Img } from "../../../../content/Content";
import './Feature.component.css'
const Feature = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    nav:true,
    nextArrow: <FaAngleRight  />,
    prevArrow: <FaAngleLeft className="FaAngleLeft" />,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  };
  const FeatureSlider = [
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature1,
      bgColor: "rgba(247, 255, 250, 1)",
      tm1:true,
    },
    {
      name: "FRX Educators",
      subName: "JC Morales",
      logo: Img.FeatureLogo,
      img: Img.feature2,
      bgColor: "linear-gradient(180deg, rgba(45, 144, 141, 0) -8.59%, rgba(6, 141, 137, 0.68) 183.7%)"
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature3,
      bgColor: "rgba(247, 255, 250, 1)",
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature4,
      bgColor: "rgba(247, 255, 250, 1)",
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature1,
      bgColor: "rgba(247, 255, 250, 1)",
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature1,
      bgColor: "rgba(247, 255, 250, 1)",
    },
  ];
  const [showSlide,setSlide]=useState(false)
  const productSide = showSlide? FeatureSlider.slice(1, 10): FeatureSlider.slice(1, 4);
  return (
    <VStack bgColor='rgba(245, 245, 255, 1)'>
      {/* desktop-feature */}
      <Box className="desktop-feature" w="80%" mx="auto" bgColor='rgba(255, 255, 255, 1)' p='50px 40px' borderRadius='18px' position='relative' top='-66px'>
        <Stack>
          <Text color='rgba(0, 0, 0, 1)' fontSize='30px' fontWeight='700'>Top Featured Sessions</Text>

          {/* Carousel */}
          <Stack>
            <Slider {...settings}>
              {FeatureSlider.map((item) => (
                <VStack>
                  <Stack
                    h="auto"
                    boxShadow="0px 0px 11px 0px rgba(0, 0, 0, 0.13)"
                    borderRadius="18px"
                    margin="15px"
                  >
                    <Box textAlign='center' py="10px">
                      <Text fontSize='20px' fontWeight='400' color='rgba(0, 0, 0, 1)'>{item.name}</Text>
                      <Text color='rgba(0, 0, 0, 1)' fontSize='20px' fontWeight='700' mt='0'>{item.subName}</Text>
                    </Box>
                    <Box w='85%' mx='auto'bgColor={item.bgColor} h={'303px'} position='relative' paddingBottom='20px' >
                        <Image src={item.logo} alt="logo" position={'absolute'} top='10px' left={'10px'} w={'57px'}/>
                        <Image src={item.img} alt="logo" w='100%' borderRadius='32px' h='100%' objectFit={item.tm1 ===true ? 'contain':'cover'} />
                    </Box>
                  </Stack>
                </VStack>
              ))}
            </Slider>
          </Stack>
        </Stack>
      </Box>

      {/* mobile-feature */}
      <Box className="mobile-feature" my="50px" w="85%" mx="auto" bgColor='rgba(255, 255, 255, 1)' p='50px 20px' borderRadius='18px' >
        <Stack>
          <Text            
            fontSize="24px"
            fontFamily="ProximaNova"
            fontWeight="700" 
            textAlign='center' 
            py="15px" 
            color='rgba(0, 0, 0, 1)'
            >Top Featured Sessions</Text>

          {/* Carousel */}
          <Stack w="100%" h="100%" >
              {productSide.map((item) => (
                <VStack w="100%">
                  <Stack
                    h="100%"
                    boxShadow="0px 0px 11px 0px rgba(0, 0, 0, 0.13)"
                    borderRadius="18px"
                    margin="15px"
                    w="100%"
                  >
                    <Box textAlign='center' py="10px">
                      <Text fontSize='20px' fontWeight='400' color='rgba(0, 0, 0, 1)'>{item.name}</Text>
                      <Text color='rgba(0, 0, 0, 1)' fontSize='20px' fontWeight='700' mt='0'>{item.subName}</Text>
                    </Box>
                    <Box w='85%' mx='auto'bgColor={item.bgColor} h={'100%'} position='relative' paddingBottom='20px' >
                        <Image src={item.logo} alt="logo" position={'absolute'} top='10px' left={'10px'} w={'57px'}/>
                        <Image src={item.img} alt="logo" w='100%' borderRadius='32px' h='100%' objectFit={item.tm1 ===true ? 'contain':'cover'} />
                    </Box>
                  </Stack>
                </VStack>
              ))}
                <Button 
                w="60%" 
                mx="auto" 
                bg="rgba(0, 113, 193, 1)" 
                color="#fff"
                fontSize="20px"
                fontFamily="'Roboto', sans-serif"
                fontWeight="400" 
                textAlign='center' 
                h="49px"
                _hover={{
                  color: '#ffff'
                }}
                onClick={()=>setSlide(!showSlide)}
                >
                    Show more
                </Button>
          </Stack>
        </Stack>
      </Box>          

    </VStack>
  );
};

export default Feature;
